import moment from 'moment';
import {EXCERPTED} from '../constants/Fixtures';

export function formattedDate(dateString) {
  return moment(dateString).format("ddd, MMM. D, h:mm");
}

export function olderThanMinutes(dateString, minutes) {
  let minutesAgo = moment().subtract(minutes, 'minutes');
  return minutesAgo.isBefore(moment(dateString));
}

export function warnOnPageLeave(e) {
  e.preventDefault();
  return "You are leaving the project creation page. Changes may not be saved.";
}

export function bytesToSize(bytes) {
   var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
   if (bytes == 0) return '0 Byte';
   var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
   return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

let lastId = 0;

export function newId(prefix = 'id') {
  lastId++;
  return `${prefix}${lastId}`;
}

export function getLastId() {
  return lastId;
}

export function getLimitedText(text, limit = 40) {
  if (!text) {
    return null;
  } else if (text.length < limit) {
    return text;
  } else {
    const substr = text.substring(0, limit);
    return substr + EXCERPTED;
  }
}
